import { ONE_MINUTE, generateUUID, createValueHistory, elapsed } from '@datadog/browser-core';
import { trackEventCounts } from '../trackEventCounts';
export const ACTION_CONTEXT_TIME_OUT_DELAY = 5 * ONE_MINUTE; // arbitrary
export function startActionTracker(lifeCycle) {
    const history = createValueHistory({ expireDelay: ACTION_CONTEXT_TIME_OUT_DELAY });
    const activeEventCountSubscriptions = new Set();
    const sessionRenewalSubscription = lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, () => {
        history.reset();
        activeEventCountSubscriptions.forEach((subscription) => subscription.stop());
        activeEventCountSubscriptions.clear();
    });
    function createTrackedAction(startClocks) {
        const id = generateUUID();
        const historyEntry = history.add(id, startClocks.relative);
        let duration;
        const eventCountsSubscription = trackEventCounts({
            lifeCycle,
            isChildEvent: (event) => event.action !== undefined &&
                (Array.isArray(event.action.id) ? event.action.id.includes(id) : event.action.id === id),
        });
        activeEventCountSubscriptions.add(eventCountsSubscription);
        function cleanup() {
            eventCountsSubscription.stop();
            activeEventCountSubscriptions.delete(eventCountsSubscription);
        }
        return {
            id,
            startClocks,
            get duration() {
                return duration;
            },
            get counts() {
                return eventCountsSubscription.eventCounts;
            },
            stop(endTime) {
                historyEntry.close(endTime);
                duration = elapsed(startClocks.relative, endTime);
                cleanup();
            },
            discard() {
                historyEntry.remove();
                cleanup();
            },
        };
    }
    function findActionId(startTime) {
        const ids = history.findAll(startTime);
        return ids.length ? ids : undefined;
    }
    function stop() {
        sessionRenewalSubscription.unsubscribe();
        activeEventCountSubscriptions.forEach((subscription) => subscription.stop());
        activeEventCountSubscriptions.clear();
        history.reset();
        history.stop();
    }
    return { createTrackedAction, findActionId, stop };
}
//# sourceMappingURL=trackAction.js.map